"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { LuPencil } from "react-icons/lu";
const INSIGHT_FACTORS = [{
  id: "realWorldEffectiveness",
  label: "Real-world effectiveness in typical patients"
}, {
  id: "consistencyResults",
  label: "Consistency of results over time"
}, {
  id: "tolerabilitySafety",
  label: "Tolerability / safety profile"
}, {
  id: "patientAcceptance",
  label: "Patient acceptance or preference"
}, {
  id: "accessCoverage",
  label: "Access, coverage, or reimbursement barriers"
}, {
  id: "easeOfUse",
  label: "Ease of use (dosing, administration, setup, workflow)"
}, {
  id: "clinicalGuidelines",
  label: "Fit within current clinical guidelines or pathways"
}, {
  id: "differentiationAlternatives",
  label: "Differentiation vs alternatives in real practice"
}, {
  id: "supportTraining",
  label: "Availability of support, training, or samples"
}, {
  id: "other",
  label: "Other factor",
  hasInput: true
}];
const RealWorldInsight = t0 => {
  const $ = _c(63);
  const {
    clinicalInsight,
    setClinicalInsight,
    productName,
    selectedIndication,
    onBack,
    onNext,
    isSubmitting: t1,
    submitError: t2,
    selectedFactors: t3,
    setSelectedFactors,
    otherText: t4,
    setOtherText
  } = t0;
  const isSubmitting = t1 === undefined ? false : t1;
  const submitError = t2 === undefined ? null : t2;
  let t5;
  if ($[0] !== t3) {
    t5 = t3 === undefined ? [] : t3;
    $[0] = t3;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const selectedFactors = t5;
  const otherText = t4 === undefined ? "" : t4;
  let t6;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = [];
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  const [selectedLabels, setSelectedLabels] = useState(t6);
  const [localOtherText, setLocalOtherText] = useState("");
  const factors = setSelectedFactors ? selectedFactors : selectedLabels;
  const setFactors = setSelectedFactors || setSelectedLabels;
  const otherValue = setOtherText ? otherText : localOtherText;
  const setOtherValue = setOtherText || setLocalOtherText;
  let t7;
  if ($[3] !== factors || $[4] !== setFactors || $[5] !== setOtherValue) {
    t7 = factor => {
      const label = factor.label;
      if (factors.includes(label)) {
        setFactors(factors.filter(f => f !== label));
        if (factor.id === "other") {
          setOtherValue("");
        }
      } else {
        setFactors([...factors, label]);
      }
    };
    $[3] = factors;
    $[4] = setFactors;
    $[5] = setOtherValue;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  const handleFactorToggle = t7;
  let t8;
  if ($[7] !== factors) {
    t8 = factors.includes("Other factor");
    $[7] = factors;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  const isOtherSelected = t8;
  const isFormValid = factors.length > 0;
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="flex items-center gap-2 sm:gap-3 mb-2"><div className="w-8 h-8 sm:w-10 sm:h-10 rounded-lg bg-primary-primaryBlue/10 flex items-center justify-center flex-shrink-0"><LuPencil className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-primary-primaryBlue" /></div><h2 className="text-base sm:text-xl font-bold text-gray-900 font-poppins">Clinical Insights</h2></div>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  const t10 = productName || "this product";
  let t11;
  if ($[10] !== t10) {
    t11 = <span className="font-semibold">{t10}</span>;
    $[10] = t10;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  const t12 = selectedIndication || "No indication";
  let t13;
  if ($[12] !== t12) {
    t13 = <span className="font-semibold">{t12}</span>;
    $[12] = t12;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] !== t11 || $[15] !== t13) {
    t14 = <p className="text-xs sm:text-sm text-gray-600 font-poppins mb-4 sm:mb-6">What most influences your use of {t11} for {t13}? Select all that apply.</p>;
    $[14] = t11;
    $[15] = t13;
    $[16] = t14;
  } else {
    t14 = $[16];
  }
  let t15;
  if ($[17] !== factors || $[18] !== handleFactorToggle) {
    t15 = INSIGHT_FACTORS.map(factor_0 => <div key={factor_0.id} className="flex items-start gap-2 sm:gap-3"><label className="flex items-start gap-2 sm:gap-3 cursor-pointer group"><div className="relative flex-shrink-0 mt-0.5"><input type="checkbox" checked={factors.includes(factor_0.label)} onChange={() => handleFactorToggle(factor_0)} className="sr-only peer" /><div className={`w-4 h-4 sm:w-5 sm:h-5 border-2 rounded-md transition-all flex items-center justify-center ${factors.includes(factor_0.label) ? "border-primary-primaryBlue bg-primary-primaryBlue" : "border-gray-300"}`}>{factors.includes(factor_0.label) && <svg className="w-2.5 h-2.5 sm:w-3 sm:h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}><path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" /></svg>}</div></div><span className="text-xs sm:text-sm text-gray-700 font-poppins group-hover:text-gray-900 transition-colors">{factor_0.label}{factor_0.hasInput && <span className="text-gray-400"> (optional comment)</span>}</span></label></div>);
    $[17] = factors;
    $[18] = handleFactorToggle;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  if ($[20] !== t15) {
    t16 = <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4 mb-4 sm:mb-6">{t15}</div>;
    $[20] = t15;
    $[21] = t16;
  } else {
    t16 = $[21];
  }
  let t17;
  if ($[22] !== isOtherSelected || $[23] !== otherValue || $[24] !== setOtherValue) {
    t17 = isOtherSelected && <div className="mb-4 sm:mb-6"><input type="text" value={otherValue} onChange={e => setOtherValue(e.target.value)} placeholder="Optional" className="w-full max-w-md rounded-lg border-2 border-gray-200 focus:border-primary-primaryBlue focus:outline-none transition-colors px-3 sm:px-4 py-2 text-xs sm:text-sm font-poppins" /></div>;
    $[22] = isOtherSelected;
    $[23] = otherValue;
    $[24] = setOtherValue;
    $[25] = t17;
  } else {
    t17 = $[25];
  }
  let t18;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <span className="font-semibold">Optional:</span>;
    $[26] = t18;
  } else {
    t18 = $[26];
  }
  let t19;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <label className="block text-xs sm:text-sm font-medium text-gray-900 font-poppins mb-2">{t18} Add context in your own words{" "}<span className="text-gray-400 font-normal">(Recommended)</span></label>;
    $[27] = t19;
  } else {
    t19 = $[27];
  }
  let t20;
  if ($[28] !== setClinicalInsight) {
    t20 = e_0 => setClinicalInsight(e_0.target.value);
    $[28] = setClinicalInsight;
    $[29] = t20;
  } else {
    t20 = $[29];
  }
  let t21;
  if ($[30] !== clinicalInsight || $[31] !== t20) {
    t21 = <div className="border-t border-gray-100 pt-4 sm:pt-6">{t19}<textarea value={clinicalInsight} onChange={t20} placeholder="Share any additional real-world observations that may help peers. Optional." className="w-full rounded-lg border-2 border-gray-200 focus:border-primary-primaryBlue focus:outline-none transition-colors p-3 sm:p-4 resize-none text-xs sm:text-sm font-poppins" rows={3} /></div>;
    $[30] = clinicalInsight;
    $[31] = t20;
    $[32] = t21;
  } else {
    t21 = $[32];
  }
  let t22;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <p className="mt-3 sm:mt-4 text-xs sm:text-sm text-gray-500 font-poppins">Check the key factors first, then add insight if desired. <span className="font-semibold">Text is optional.</span></p>;
    $[33] = t22;
  } else {
    t22 = $[33];
  }
  let t23;
  if ($[34] !== t16 || $[35] !== t17 || $[36] !== t21) {
    t23 = <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-4 sm:p-6">{t16}{t17}{t21}{t22}</div>;
    $[34] = t16;
    $[35] = t17;
    $[36] = t21;
    $[37] = t23;
  } else {
    t23 = $[37];
  }
  let t24;
  if ($[38] !== t14 || $[39] !== t23) {
    t24 = <div className="flex-1 overflow-y-auto hide-scrollbar px-4 sm:px-6 py-3 sm:py-4"><div className="mb-4 sm:mb-6">{t9}{t14}{t23}</div></div>;
    $[38] = t14;
    $[39] = t23;
    $[40] = t24;
  } else {
    t24 = $[40];
  }
  let t25;
  if ($[41] !== submitError) {
    t25 = submitError && <div className="bg-red-50 border border-red-200 rounded-lg px-3 sm:px-4 py-2 sm:py-3 flex items-center gap-2"><svg className="w-4 h-4 sm:w-5 sm:h-5 text-red-500 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" /></svg><p className="text-xs sm:text-sm text-red-700 font-poppins">{submitError}</p></div>;
    $[41] = submitError;
    $[42] = t25;
  } else {
    t25 = $[42];
  }
  const t26 = `flex-1 border-2 border-gray-300 text-gray-700 text-sm sm:text-base font-semibold font-poppins rounded-lg py-2.5 sm:py-3 transition-colors ${isSubmitting ? "opacity-50 cursor-not-allowed" : "hover:bg-gray-50"}`;
  let t27;
  if ($[43] !== isSubmitting || $[44] !== onBack || $[45] !== t26) {
    t27 = <button onClick={onBack} disabled={isSubmitting} className={t26}>Back</button>;
    $[43] = isSubmitting;
    $[44] = onBack;
    $[45] = t26;
    $[46] = t27;
  } else {
    t27 = $[46];
  }
  const t28 = !isFormValid || isSubmitting;
  const t29 = `flex-1 text-white rounded-lg text-sm sm:text-base font-semibold font-poppins py-2.5 sm:py-3 transition-all ${isFormValid && !isSubmitting ? "bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 shadow-md hover:shadow-lg transform hover:scale-[1.02]" : "bg-gray-300 cursor-not-allowed"}`;
  let t30;
  if ($[47] !== isSubmitting) {
    t30 = isSubmitting ? <span className="flex items-center justify-center gap-2"><svg className="animate-spin h-4 w-4 sm:h-5 sm:w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" /><path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" /></svg><span className="hidden sm:inline">Submitting...</span><span className="sm:hidden">Submit...</span></span> : "Submit Review";
    $[47] = isSubmitting;
    $[48] = t30;
  } else {
    t30 = $[48];
  }
  let t31;
  if ($[49] !== onNext || $[50] !== t28 || $[51] !== t29 || $[52] !== t30) {
    t31 = <button disabled={t28} onClick={onNext} className={t29}>{t30}</button>;
    $[49] = onNext;
    $[50] = t28;
    $[51] = t29;
    $[52] = t30;
    $[53] = t31;
  } else {
    t31 = $[53];
  }
  let t32;
  if ($[54] !== t27 || $[55] !== t31) {
    t32 = <div className="flex gap-2 sm:gap-3">{t27}{t31}</div>;
    $[54] = t27;
    $[55] = t31;
    $[56] = t32;
  } else {
    t32 = $[56];
  }
  let t33;
  if ($[57] !== t25 || $[58] !== t32) {
    t33 = <div className="px-4 sm:px-6 py-3 sm:py-4 border-t border-gray-200 bg-white flex flex-col gap-2 sm:gap-3 flex-shrink-0">{t25}{t32}</div>;
    $[57] = t25;
    $[58] = t32;
    $[59] = t33;
  } else {
    t33 = $[59];
  }
  let t34;
  if ($[60] !== t24 || $[61] !== t33) {
    t34 = <>{t24}{t33}</>;
    $[60] = t24;
    $[61] = t33;
    $[62] = t34;
  } else {
    t34 = $[62];
  }
  return t34;
};
export default RealWorldInsight;